import React, { useState, useRef, useEffect } from "react";
import bgImage from "../assets/translatebg.jpg";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

const languageOptions = [
  { value: "en", label: "English" },
  { value: "es", label: "Spanish" },
  { value: "fr", label: "French" },
];

function Translate() {
  const [selectedLanguage1, setSelectedLanguage1] = useState("");
  const [selectedLanguage2, setSelectedLanguage2] = useState("");
  const [textArea1Value, setTextArea1Value] = useState("");
  const [textArea2Value, setTextArea2Value] = useState("");
  const [showTextarea1, setShowTextarea1] = useState(false);
  const [showTextarea2, setShowTextarea2] = useState(false);

  const textarea1Ref = useRef(null);
  const textarea2Ref = useRef(null);
  const navigate = useNavigate();

  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: 300,
      marginBottom: 10,
    }),
  };

  const adjustTextareaHeight = (textareaRef) => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  const handleLanguageChange1 = (selectedOption) => {
    setSelectedLanguage1(selectedOption);
    setShowTextarea1(true);
  };

  const handleLanguageChange2 = (selectedOption) => {
    setSelectedLanguage2(selectedOption);
    setShowTextarea2(true);
  };

  const handleSwapLanguages = () => {
    const tempLanguage = selectedLanguage1;
    setSelectedLanguage1(selectedLanguage2);
    setSelectedLanguage2(tempLanguage);
  };

  const handleTextareaChange1 = (event) => {
    setTextArea1Value(event.target.value);
    adjustTextareaHeight(textarea1Ref);
  };

  const handleTextareaChange2 = (event) => {
    setTextArea2Value(event.target.value);
    adjustTextareaHeight(textarea2Ref);
  };

  useEffect(() => {
    adjustTextareaHeight(textarea1Ref);
    adjustTextareaHeight(textarea2Ref);
  }, []);

  return (
    <div
      className="relative min-h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      <nav className="fixed top-0 left-0 right-0 text-white p-4 flex justify-center items-center z-10">
        <button onClick={() => navigate('/app')} className="absolute z-20 cursor-pointer left-4 text-white">
          <img
            src="https://img.icons8.com/?size=100&id=EiJnl8UJCjVI&format=png&color=999999"
            alt="Home"
            className="h-8 w-8"
          />
        </button>
        <h1 className="self-center whitespace-nowrap text-3xl font-semibold text-white cursor-pointer" onClick={() => navigate("/app")}>GemX</h1>
        <div className="absolute right-4 rounded-full bg-gray-300 overflow-hidden w-12 h-12">
          <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="User Avatar" />
        </div>
      </nav>
      <div className="flex flex-col items-center justify-center top-28 px-4 py-8 relative z-10">
        <div className="max-w-7xl w-full flex flex-col lg:flex-row items-center">
          <div className="flex-1 flex flex-col items-center lg:items-start lg:text-left mb-8 lg:mb-0">
            <img
              src="robot.png"
              alt="Robot"
              className="hidden lg:block lg:w-60 lg:h-auto lg:mt-6 lg:transform lg:translate-x-10"
            />
            <h2 className="text-2xl text-white font-bold mb-4 lg:-ml-5">
              Translate your text to any language!</h2>
          </div>
          <div className="flex-1 mt-8 lg:mt-0 lg:ml-auto lg:mr-0 text-center lg:text-right">
            <h2 className="text-3xl text-white font-bold mb-4 lg:mr-20">
              Gemx Translate!
            </h2>
            <div className="relative p-8 rounded-lg shadow-lg lg:ml-auto">
              <div className="relative z-10">
                <div className="mb-4 lg:mb-8 flex justify-end items-center">
                  {showTextarea1 ? (
                    <>
                      <textarea
                        ref={textarea1Ref}
                        className="mt-1 ml-2 block w-full max-w-xs dark:bg-black focus:outline-primary dark:focus-within:bg-black text-black border rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-lg resize-none"
                        placeholder={`Enter text in ${selectedLanguage1.label}`}
                        value={textArea1Value}
                        onChange={handleTextareaChange1}
                        style={{
                          minHeight: "50px",
                          maxHeight: "200px",
                          textAlign: "center",
                        }}
                      />
                      <button className="ml-2 p-2 rounded-full bg-blue-500 text-white">
                        <img
                          src="https://img.icons8.com/?size=100&id=12653&format=png&color=FFFFFF"
                          alt="mic"
                          className="w-5 h-5"
                        />
                      </button>
                    </>
                  ) : (
                    <Select
                      className="mt-1 ml-2 block w-full max-w-xs dark:bg-black focus:outline-primary dark:focus-within:bg-black"
                      options={languageOptions}
                      styles={customStyles}
                      onChange={handleLanguageChange1}
                      placeholder="Select Language 1"
                      isSearchable={true}
                      noOptionsMessage={() => "No languages found"}
                    />
                  )}
                </div>
                <div className="flex justify-end mb-4 lg:mb-8">
                  <button className="p-2" onClick={handleSwapLanguages}>
                    <img
                      src="https://img.icons8.com/?size=100&id=bke82KwR2uwg&format=png&color=FFFFFF"
                      alt="swapImage"
                      className="w-10 h-10 lg:-translate-x-32 sm:-translate-x-12 -translate-x-12"
                    />
                  </button>
                </div>
  
                <div className="mb-4 lg:mb-8 flex justify-end items-center">
                  {showTextarea2 ? (
                    <>
                      <textarea
                        ref={textarea2Ref}
                        className="mt-1 ml-2 block w-full max-w-xs text-black dark:bg-black focus:outline-primary dark:focus-within:bg-black bg-white border rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-lg resize-none"
                        placeholder={`Enter text in ${selectedLanguage2.label}`}
                        value={textArea2Value}
                        onChange={handleTextareaChange2}
                        style={{
                          minHeight: "50px",
                          maxHeight: "200px",
                          textAlign: "center",
                        }}
                      />
                      <button className="ml-2 p-2 rounded-full bg-green-500 text-white">
                        <img
                          src="https://img.icons8.com/?size=100&id=11408&format=png&color=FFFFFF"
                          alt="speaker"
                          className="w-5 h-5"
                        />
                      </button>
                    </>
                  ) : (
                    <Select
                      className="mt-1 ml-2 block w-full max-w-xs dark:bg-black focus:outline-primary dark:focus-within:bg-black"
                      options={languageOptions}
                      styles={customStyles}
                      onChange={handleLanguageChange2}
                      placeholder="Select Language 2"
                      isSearchable={true}
                      noOptionsMessage={() => "No languages found"}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  
}

export default Translate;
